module.exports = __webpack_public_path__ + "static/media/flare_dress.33f9c113.png";